export const LEGAL_NAME = "1APPONLY (OPC) PRIVATE LIMITED";
export const WEBSITE = "www.1apponly.com";

export const BRAND = {
  wordmark: "/1apponly-logo.webp",
  square: "/1apponly-logo.webp",
  loginBg:
    "https://images.unsplash.com/photo-1704975986930-0c09f513c985?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdyZWVuJTIwZ2VvbWV0cmljfGVufDB8fHx8MTc4NzkyMTA0OXww&ixlib=rb-4.1.0&q=85",
};
